import { useNavigate } from 'react-router-dom';

import { getProviderCapabilities } from '../../entities/provider';
import { ProjectLike } from '../../shared/contexts/Projects.provider';

interface OtherProjectsCardProps {
  projects: ProjectLike[];
}

// Lists projects from providers with no portfolio-wide overview yet (anything with
// supportsStudioOverview: false in entities/provider.ts) as simple link cards. Used on the
// studio/projects pages so a Trello- or Standalone-only user sees something instead of an
// empty Jira-shaped dashboard. Collapsible (defaults open) so it doesn't compete for attention
// with the Jira metrics below it once both are present — same <details> pattern as the
// Integrations page's "Privacy & data handling" section.
export function OtherProjectsCard({ projects }: OtherProjectsCardProps) {
  const navigate = useNavigate();
  if (!projects.length) return null;

  return (
    <details className="collapse collapse-arrow bg-base-100 shadow-card rounded-xl" open>
      <summary className="collapse-title min-h-0 py-4">
        <div className="text-lg font-semibold">Other projects ({projects.length})</div>
        <div className="text-sm opacity-70">
          These providers don&apos;t have a portfolio-wide overview yet — open a project directly.
        </div>
      </summary>
      <div className="collapse-content">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {projects.map((p) => (
            <button
              key={p._id}
              className="flex items-center justify-between gap-2 rounded-lg bg-base-200 hover:bg-base-300 hover:-translate-y-0.5 transition p-3 text-left"
              onClick={() =>
                navigate(p.provider === 'standalone' ? `/standalone/${p._id}` : `/dashboard/projects/${p._id}`)
              }
            >
              <span className="font-medium truncate">{p.name}</span>
              <span className="badge badge-sm badge-outline shrink-0">{getProviderCapabilities(p.provider).label}</span>
            </button>
          ))}
        </div>
      </div>
    </details>
  );
}
